import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LOGO_URL } from "../lib/site";

export default function SignupSuccess() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="signup-success-page">
      <div className="w-full max-w-md text-center">
        <Link to="/" className="flex flex-col items-center gap-2 mb-8">
          <img src={LOGO_URL} alt="CashPark" className="h-14 w-14" />
          <span className="font-display font-bold text-xl text-[#0B192C]">CashPark <span className="text-[#FF6B00]">Inc</span></span>
        </Link>
        <div className="bg-white rounded-3xl border border-slate-200 p-10 shadow-sm">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-emerald-50 text-emerald-600 flex items-center justify-center">
            <CheckCircle2 size={36} />
          </div>
          <h1 className="font-display text-2xl font-bold text-[#0B192C] mt-5">You're registered!</h1>
          <p className="mt-2 text-slate-600">Your CashPark account has been created. Sign in to access your dashboard.</p>
          <Link to="/login" data-testid="success-go-login">
            <Button className="mt-6 w-full h-11 rounded-full bg-[#FF6B00] hover:bg-[#E65C00] font-semibold">
              Sign in to dashboard
            </Button>
          </Link>
          <Link to="/" className="mt-3 inline-block text-sm text-slate-500 hover:text-[#FF6B00]">← Back to home</Link>
        </div>
      </div>
    </div>
  );
}
